import { Navigate, Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectorPermissions } from '@/stores/auth';
import { CalendarAltSvg, ChildSvg, EmailSvg, FileAltSvg, HistorySvg, StreamSvg, UserSvg } from '@/assets/icons';
import Page from '@/components/page';
import PageTitle from '@/components/page-title';
import Panel from '@/components/panel';
import ChildInquiries from './child-inquiries';
import GeneralInquiries from './general-inquiries';
import Events from './events';
import Documents from './documents';
import Family from './family';
import Activity from './activity';
import PlacementHistory from './placement-history';
import AdoptionHistory from './adoption-history';
import ParentInfo from './parent-info';
import RecommendationInfo from './recommendation-info';
import FosterCareLicense from './foster-care-license';
import LeadSource from './lead-source';
import { Col, Row } from 'antd';
import FamilyTabsView from './family-tabs';
import { useState } from 'react';

const breadcrumb = [{ path: '/parent', label: 'Parents' }, 'View'];

// const panels = [ParentInfo, FamilyStatus, FamilyNotes, RecommendationInfo, FosterCareLicense, LeadSource];

const titles = {
  'child-inquiries': 'Child Inquiries',
  'general-inquiries': 'General Inquiries',
  events: 'Events',
  documents: 'Documents',
  family: 'Seeking & Current Family',
  activity: 'Activity',
  placements: 'Placement History',
  adoptions: 'Adoption History',
};

const tabItems = [
  { key: 'child-inquiries', icon: UserSvg, label: 'Child Inquiries', component: ChildInquiries },
  { key: 'general-inquiries', icon: EmailSvg, label: 'General Inquiries', component: GeneralInquiries },
  { key: 'events', icon: CalendarAltSvg, label: 'Events', component: Events },
  { key: 'documents', icon: FileAltSvg, label: 'Documents', component: Documents },
  { key: 'family', icon: ChildSvg, label: 'Family', component: Family },
  { key: 'activity', icon: StreamSvg, label: 'Activity', component: Activity },
  { key: 'placements', icon: StreamSvg, label: 'Match/Placement History', component: PlacementHistory },
  { key: 'adoptions', icon: HistorySvg, label: 'Adoption History', component: AdoptionHistory },
];

const tabTitles = tabItems.map(({ key, icon: Icon, label }) => ({
  key,
  label: (
    <>
      <Icon />
      {label}
    </>
  ),
}));

const ParentViewPage = () => {
  const permissions = useSelector(selectorPermissions);
  const { parentId } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [shouldRefetch, setShouldRefetch] = useState(false);

  const activeTabKey = pathname
    .split('/')
    .filter((s) => s)
    .pop();

  return (
    <Page breadcrumb={breadcrumb} size="xl">
      <PageTitle label={titles[activeTabKey]} />
      {/* {panels.map((Component, i) => (
        <Component key={i} parentId={parentId} permissions={permissions} />
      ))} */}
      <Row gutter={30}>
        <Col lg={24} xl={15}>
          <div style={{ marginBottom: '20px' }}>
            <ParentInfo parentId={parentId} permissions={permissions} />
          </div>
          <div style={{ marginBottom: '20px' }}>
            <Panel tabList={tabTitles} activeTabKey={activeTabKey} onTabChange={(key) => navigate(key)}>
              <Routes>
                {tabItems.map(({ key, component: Component }) => (
                  <Route key={key} path={key} element={<Component parentId={parentId} permissions={permissions} />} />
                ))}
                <Route path="*?" element={<Navigate to="child-inquiries" replace />} />
              </Routes>
            </Panel>
          </div>
        </Col>
        <Col lg={24} xl={9}>
          <div style={{ marginBottom: '10px' }}>
            <FamilyTabsView parentId={parentId} permissions={permissions} />
          </div>
          <div style={{ marginBottom: '10px' }}>
            <RecommendationInfo
              parentId={parentId}
              permissions={permissions}
              shouldRefetch={shouldRefetch}
              setShouldRefetch={setShouldRefetch}
            />
          </div>
          <div style={{ marginBottom: '10px' }}>
            <FosterCareLicense parentId={parentId} permissions={permissions} setShouldRefetch={setShouldRefetch} />
          </div>
          <div style={{ marginBottom: '10px' }}>
            <LeadSource parentId={parentId} permissions={permissions} />
          </div>
        </Col>
      </Row>
    </Page>
  );
};

export default ParentViewPage;
